<template>
  <div class="store">
    <EsHeaderView :isStore="true" />

    <div class="wrap app-center">
      <div class="head-wrap">
        <img :src="$getImageUrl(filterBanner[0])" class="banner" v-if="filterBanner.length < 2" />
        <swiper :options="option" v-else>
          <swiper-slide v-for="(item, i) in filterBanner" :key="i">
            <img :src="$getImageUrl(item)" alt="" />
          </swiper-slide>
        </swiper>
        <div class="box">
          <div class="container-left">
            <img :src="$getImageUrl(store.avatar)" :alt="store.name" />
            <div class="desc">
              <p>{{ store.name }}</p>
              <span>
                {{ store.shopRemark }}
              </span>
              <div class="img-list">
                <a v-if="store.facebook" :href="store.facebook" target="_blank" referrerpolicy="no-referrer">
                  <img src="../../assets/image/facebook.png" alt="" />
                </a>
                <a v-if="store.twitter" :href="store.twitter" target="_blank" referrerpolicy="no-referrer">
                  <img src="../../assets/image/twitter.png" alt="" />
                </a>
                <a v-if="store.google" :href="store.google" target="_blank" referrerpolicy="no-referrer">
                  <img src="../../assets/image/google.png" alt="" />
                </a>
                <a v-if="store.youtube" :href="store.youtube" target="_blank" referrerpolicy="no-referrer">
                  <img src="../../assets/image/youtube.png" alt="" />
                </a>
                <a v-if="store.instagram" :href="store.instagram" target="_blank" referrerpolicy="no-referrer">
                  <img src="../../assets/image/instagram.png" alt="" />
                </a>
              </div>
            </div>
          </div>
          <el-button class="btn" @click="follow">
            <i :class="
              // 1 已关注 0 未关注
              store.isFocus === followStatus.on
                ? 'el-icon-star-on'
                : 'el-icon-star-off'
              "></i>
            {{
              store.isFocus === followStatus.on
                ? this.$t("message.home.followed" /**關注 */)
                : this.$t("message.home.followers")
            }}
          </el-button>
        </div>
      </div>

      <div class="nav">
        <ul>
          <li>
            {{ obj.name }}
          </li>
          <li>
            <el-button @click="store_favorite_add" class="btn">
              <i class="el-icon-star-off"></i>
            </el-button>
          </li>
        </ul>
      </div>

      <div class="nav">
        <ul>
          <li v-for="(item, index) in navlist" :key="index" @click="liEvent(index)"
            :class="activeIndex === index ? 'active' : ''">
            {{ $t(item.name) }}
          </li>
        </ul>
      </div>


      <div class="app-container store-content" ref="storePage">

        <div class="commodity recommend">
          <div class="app-container">
            <!-- <div class="recommend-swiper">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide v-for="item in bannerList" :key="item">
            <img :src="item" alt="" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div> -->

            <div class="commodity-wrap flex-start">
              <div v-loading="pageLoading" class="commodity-content">
                <div ref="commodityL">
                  <div v-if="objsList.length" class="commodity-content-item">
                    <div v-for="(item, index) in objsList" :key="item.goodsId + '_' + index" class="item">
                      <EsProductView :item="item" />
                    </div>
                  </div>
                  <div v-if="objsList.length" class="commodity-content-pagination">
                    <el-pagination background layout="total,prev, pager, next" class="es-pagination"
                      :page-size="queryParams.pageSize" :current-page="queryParams.pageNumber" :total="total"
                      @current-change="currentChange" />
                  </div>
                  <div class="no-data" v-if="!objsList.length && !pageLoading">
                    <el-empty :description="$t('message.home.noData')"></el-empty>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- <EsRecommed ref="EsRecommed" v-if="activeIndex === 0" />
        <EsSort v-else-if="activeIndex === 1" /> -->
        <!-- <EsCommodity v-else-if="activeIndex === 1" /> -->
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import EsRecommed from "./recommend.vue";
// import EsCommodity from './commodity.vue'
import EsSort from "./sort.vue";
import { notLogin } from "@/common/pageHook";
import defaultImg from "@/assets/image/shopBanner.png";
import storeBg from "@/assets/image/store_bg.png";
//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  store_list //商品列表
} from "@/api/goods/goods.js"
import {
  index //商家详情
} from "@/api/store/store.js"
import {
  add
} from "@/api/upms/store_favorite.js"
import EsProductView from "@/components/product";

//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  name: "EsStore",
  components: { EsProductView },
  // components: { 
  // EsRecommed, 
  // EsSort
  //  },
  data() {
    return {
      navlist: [
        // {
        //   name: "message.home.recommend",
        // },
        {
          name: "message.home.allProduct",
        },
        // {
        //   name: 'Commodity',
        // },
        // {
        //   name: 'Sort',
        // },
      ],
      swiperOptions1: {
        // direction: "vertical",
        // 改变swiper样式时，自动初始化swiper
        observer: true,
        // 监测swiper父元素，如果有变化则初始化swiper
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
      },
      option: {},
      filterBanner: [],
      activeIndex: 0,
      loading: false,
      isCollect: false,
      followStatus: {
        on: 1, // 已关注
        off: 0, // 未关注
      },
      itemname: process.env.VUE_APP_ITEM_NAME,
      scrollTop: 0,

      swiperOptions: {
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      listData: [],
      pageLoading: false,
      pageNum: 1,
      pageSize: 18,
      total: 0,
      currentId: null,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      store: {
      },
      // tablist: [app.globalData.messages['shop_goods_default'], app.globalData.messages['shop_goods_salesDescTitle'], app.globalData.messages['shop_goods_createDateTitle'], app.globalData.messages['shop_goods_priceDescTitle']],
      tab_idx: 0,
      objsList: [],
      loadType: "load",
      queryParams: {
        pageNumber: 1,
        pageSize: 10,
        goodsCategoryId: "",
        brandId: "",
        marketingId: "",
        goodsLabelId: "",
        keyword: "",
        storeId: "",
        orderType: "SALES_DESC",
      },
      id: "",
      marketings: [], //店铺营销活动
      coupons: [], //店铺优惠券
      storeLevel: [], //店铺等级
      storeAdvertisingImages: [], //店铺广告图
      obj: {}, //店铺信息

      //////////////////////////////////////////////////////////////////////////////////////////////////

    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
  },
  mounted() {
    // if(this.itemname !== 'Argos'||itemname !== 'ArgosShop'){
    //   this.requestData();
    // }
    // this.getBannerData();
  },
  activated() {

    this.$nextTick(() => {
      // const refresh = this.$route.meta.refresh;
      // if (refresh) {
      //   this.activeIndex = 0;
      //   this.requestData();
      //   this.getBannerData();
      //   this.$nextTick(() => {
      //     this.$refs.EsRecommed.getListData(true);
      //   });
      // }

      //   window.addEventListener("scroll",()=>{
      //        this.scrollTop = document.documentElement.scrollTop;
      //  })


      const currentRouter = this.$router.currentRoute;
      this.id = currentRouter.query.storeId;
      this.queryParams.storeId = this.id;

      this.store_index();
      this.store_goods_list();


    });
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== "productDetails") {
      to.meta.refresh = true;
    } else {
      if (sessionStorage.getItem("storeRefresh")) {
        sessionStorage.removeItem("storeRefresh");
        to.meta.refresh = true;
      } else {
        to.meta.refresh = false;
      }
    }
    next();
  },
  // watch: {
  //   bannerData() {
  //     this.setBannerBg();
  //   },
  // },
  watch: {
    $route(to, from) {
      if (from.path == '/productDetails') {
        let pageScollTop = localStorage.getItem('storePagescrollTop');
        this.scrollPageTo(pageScollTop)
      }
    },
  },
  methods: {
    ...mapActions({
      // requestSellerInfo: "productDetails/requestSellerInfo",
      requestCollectSellerAdd: "user/requestCollectSellerAdd",
      requestCollectSellerDel: "user/requestCollectSellerDel",
      requestCollectSellerList: "user/requestCollectSellerList",
    }),
    scrollPageTo(top) {
      this.$nextTick(() => {
        document.documentElement.scrollTop = top;
      })
    },
    getBannerData() {
      const data = [];
      if (this.store.banner1) {
        data.push(this.store.banner1);
        if (this.store.banner2) {
          data.push(this.store.banner2);
        }
        if (this.store.banner3) {
          data.push(this.store.banner3);
        }
        this.filterBanner = data;
        this.option = this.swiperOptions1;
      } else {
        if (this.itemname == 'Argos' || this.itemname == 'ArgosShop') {
          this.filterBanner = [storeBg]
        } else {
          this.filterBanner = [defaultImg];
        }

      }
    },
    liEvent(index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index;
      }
    },
    async requestData() {
      try {
        const currentRouter = this.$router.currentRoute;
        const id = currentRouter.query.storeId;
        if (!id) {
          return;
        }
        this.loading = true;
        await this.requestSellerInfo({ sellerId: id });
      } finally {
        this.getBannerData();
        this.loading = false;
      }
    },
    async follow() {
      try {
        if (notLogin()) {
          return;
        }
        const currentRouter = this.$router.currentRoute;
        const id = currentRouter.query.storeId;
        if (!id) {
          return;
        }
        if (this.store.isFocus === this.followStatus.on) {
          await this.requestCollectSellerDel({
            sellerId: id,
          });
          this.$message.warning(this.$t("message.home.cancelSuccess"));
          await this.requestData();
          return;
        }
        await this.requestCollectSellerAdd({
          sellerId: id,
        });
        this.$message.success(this.$t("message.home.followedSuccess"));
        await this.requestData();
      } finally {
        //
      }
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

    store_index() {
      index(this.id).then(response => {
        //店铺
        this.obj = response.data.data.store;
        //      店铺营销
        this.marketings = response.data.data.marketings;
        //		店铺优惠券
        this.coupons = response.data.data.coupons;
        //      店铺等级
        this.storeLevel = response.data.data.storeLevel;
        //		店铺广告图
        this.storeAdvertisingImages = response.data.data.storeAdvertisingImages;
      });
    },
    store_favorite_add() {
      if (this.isLogin) {
        add({ "storeId": this.id }).then(response => {
          let statusCode = response.status;
          if (200 == statusCode) {
            this.$message({
              message: this.$t("message.home.collectionSuccess"),
              type: "success",
            });
          }
        }).catch(error => {
          let errResponse = JSON.parse(error.request.response ? error.request.response : '');
          if (errResponse && errResponse.message) {
            if (errResponse.message == 'shop_storeFavorite_exist') {
              this.$message({
                message: '店铺已被收藏',
                type: "success",
              });
            }
          }
        })
      } else {
        this.$message({
          message: this.$t("message.home.notLogin"),
          type: "warning",
        });
        this.$router.push("/login");
      }
    },

    /**
     * 查询列表 list
     */
    store_goods_list() {
      store_list(this.queryParams).then(response => {

        //下拉加载
        // if (this.loadType === "reach") {
        // 	const newObjsList = response.data.data.data.content;
        // 	newObjsList.forEach(item => this.objsList.push(item));
        // 	this.searchLoading = false;
        // 	//加载
        // } else if (this.loadType === "load") {
        this.objsList = response.data.data.data.content;
        this.queryParams.pageNumber = response.data.data.data.pageable.pageNumber;
				this.total = response.data.data.data.total;
				this.totalPages = response.data.data.data.totalPages;
        //下拉刷新
        // } else if (this.loadType === "pullDown") {
        // 	uni.stopPullDownRefresh();
        // }
      });
    },
    //商品选项卡点击事件
    checktab(e) {
      var idx = e.currentTarget.dataset.idx;
      this.tab_idx = idx;
      if (this.tab_idx == 0) {
        // 置顶降序 TOP_DESC
        this.queryParams.orderType = "TOP_DESC";
      }
      if (this.tab_idx == 1) {
        // 销量降序 SALES_DESC
        this.queryParams.orderType = "SALES_DESC";
      }
      if (this.tab_idx == 2) {
        // 日期 DATE_DESC
        this.queryParams.orderType = "DATE_DESC";
      }
      if (this.tab_idx == 3) {
        // 价格升序 PRICE_ASC
        this.queryParams.orderType = "PRICE_ASC";
      }
      this.loadType = "load";
      this.queryParams.pageNumber = 1;
      this.store_goods_list();


    },
    open() {
      // 通过组件定义的ref调用uni-popup方法 ,如果传入参数 ，type 属性将失效 ，仅支持 ['top','left','bottom','right','center']
      this.$refs.popup.open('top');
    },
    select(e) {
      if (e.index == 0) {
        this.$refs.popcontent.open('top');
      }
    },
    currentChange(page) {
      this.queryParams.pageNumber = page;
      window.scrollTo(0, 0);
      this.store_goods_list();
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

  },
  deactivated() {
    localStorage.setItem('storePagescrollTop', this.scrollTop);
  },

  getListData(flag) {
    try {
      if (flag) {
        this.pageNum = 1;
        this.currentId = this.$route.query.storeId;
      }
      this.pageLoading = true;
      MerchantProductListApi({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sellerId: this.currentId,
        isRec: 1,
      })
        .then((res) => {
          // console.log(res);
          const { pageInfo, pageList } = res.data;
          this.total = pageInfo.totalElements;
          this.listData = pageList;
          this.pageLoading = false;
          this.$Gsap.fromTo(this.$refs.commodityL, {
            delay: 0,
            duration: 1,
            y: '100',
            autoAlpha: 0,
            ease: "back.out(1.7)"
          }, {
            delay: 0.5,
            duration: 1,
            y: '0',
            autoAlpha: 1,
            ease: "back.out(1.7)"
          })
        })
        .catch(() => {
          this.pageLoading = false;
        });
    } finally {
      this.pageLoading = false;
    }

  },




};
</script>

<style lang="scss">
html[dir="rtl"] {
  .store .wrap .head-wrap .box .container-left img {
    margin-right: 0;
    margin-left: 20px;
  }

  .store .wrap .head-wrap .box .container-left {
    padding-right: 86px;
    padding-left: 0;
  }

  .store .wrap .head-wrap .box .btn {
    margin-right: 0;
    margin-left: 34px;
  }

  .commodity-content-list {
    margin-left: 0;
    margin-right: 20px;
  }

  .commodity-content-title {
    padding-left: 28px;
    padding-right: 0;
  }

  .commodity-content-title .search-content {
    right: auto;
    left: 0;
  }
}

.store {
  .wrap {
    width: 100%;
    margin-top: -13px;

    .head-wrap {
      width: 100%;
      // height: 300px;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      // padding-top: 58px;
      position: relative;
      overflow: hidden;
      transition: all 1s ease;

      .swiper-container {
        height: 100%;
      }

      .swiper-wrapper img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
      }

      .banner {
        z-index: -1;
        width: 100%;
        position: absolute;
        top: 50%;
        height: 100%;
        transform: translateY(-50%);
        object-fit: cover;
        image-rendering: pixelated;
      }

      .box {
        max-width: 1010px;
        height: 135px;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        z-index: 11;

        .bg {
          z-index: -1;
          width: 1010px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        .desc {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .container-left {
          display: flex;
          justify-content: flex-start;
          padding-left: 86px;

          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 20px;
          }

          p {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 19px;
            margin-bottom: 0;
            color: #f5f5f7;
            -webkit-text-stroke: 0px #333;
            filter: drop-shadow(2px 3px 0px rgba(51, 51, 51, .4));
          }

          span {
            font-family: "PingFang HK";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            width: 600px;
            display: inline-block;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
            color: #e0e0e0;
            margin-top: 5px;
          }

          .img-list {


            img {
              width: 26px;
              height: 26px;
              margin-right: 10px;
            }
          }
        }

        .btn {
          color: #f5f5f7;
          background: var(--color-main);
          border-radius: 25px;
          width: 95px;
          height: 24px;
          line-height: 24px;
          border: none;
          margin-right: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
          will-change: filter;
          transition: filter 800ms;

          &:hover {
            filter: drop-shadow(0 0 4px var(--color-main));
          }

          i {
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }

    .nav {
      width: 100%;
      padding: 8px 0;
      background: #212121;
      display: flex;
      align-items: center;

      ul {
        width: 100%;
        max-width: 1160px;
        list-style: none;
        margin: 0 auto;
        height: 100%;
        height: 40px;

        li {
          float: left;
          color: #fff;
          margin-right: 59px;
          font-weight: 500;
          cursor: pointer;
          height: 100%;
          line-height: 35px;
        }
      }

      .active {
        border-bottom: 2px solid var(--color-main);
      }
    }
  }

  &-content {
    padding: 27px 0 20px;
  }
}

.commodity {
  &-wrap {
    align-items: flex-start;
    margin-top: -24px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }

  &-filter {
    width: 170px;
    border-right: 1px solid var(--color-border);

    h2 {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: var(--color-title);
      border-bottom: 1px solid var(--color-border);
      padding: 20px 0;
      margin-bottom: 20px;
    }

    &-item {
      text-align: left;
      width: 100%;
      font-weight: 400;
      font-size: 12px;
      color: var(--color-black);
      padding: 12px 0;
      cursor: pointer;

      &:hover {
        color: var(--color-main);
        border-right: 2px solid var(--color-main);
      }

      &-active {
        color: var(--color-main);
        border-right: 2px solid var(--color-main);
      }
    }
  }

  &-content {
    width: 100%;

    &-title {
      color: var(--color-black);
      padding: 22px 28px 0 28px;

      h2 {
        font-weight: 500;
        font-size: 14px;
        color: var(--color-black);
      }



      li {
        margin-right: 46px;
        cursor: pointer;

        span {
          font-weight: 500;
          font-size: 14px;
          margin-right: 5px;
        }

        >div {
          flex-direction: column;
        }
      }

      .el-icon-caret-top {
        margin-bottom: -8px;
      }
    }

    &-list {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
      grid-column-gap: 14px;
      grid-row-gap: 20px;
      align-content: center;
      margin-top: 17px;
      margin-left: 20px;
    }

    &-pagination {
      width: 100%;
      text-align: center;
      padding: 40px 0;
    }

    .no-data {
      display: flex;
      justify-content: center;
    }
  }
}


.recommend {
  &-swiper {
    max-width: 1112px;
    margin: 0 auto;
    height: 198px;
    margin-bottom: 48px;

    .swiper-slide {
      height: 198px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .commodity-content {
    min-height: 300px;
  }

  .commodity-content-item {
    // overflow: hidden;
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
    grid-column-gap: 14px;
    grid-row-gap: 20px;
    align-content: center;

    >.item {

      // width: 165px;
      // margin-right: 34px;
      // margin-bottom: 30px;
      // float: left;
      // &:nth-child(6n) {
      //   margin-right: 0;
      // }
      v::deep .product {
        p {
          height: 42px !important;
        }
      }
    }
  }
}
</style>
